import QQInsightsCard from './QQInsightsCard';

export default QQInsightsCard;
